import { render } from "./LoadingXs.vue?vue&type=template&id=03096c38"
import script from "./LoadingXs.vue?vue&type=script&lang=js"
export * from "./LoadingXs.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__